var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"content"},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"pointer",attrs:{"src":require("@/assets/img/main/logo.svg"),"alt":"logo"}})]),_c('div',{staticClass:"title"},[_c('img',{attrs:{"src":require("@/assets/img/contentInfo/contentInfo.png")}})])])])
}]

export { render, staticRenderFns }